import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { MenuItem } from '../../Models/Domains/Menu/MenuItem';
import { SideMenu } from '../../Constants/Enums/Menu/SideMenu';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountMenuClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(sideMenu: SideMenu, hierarchyId: string, subAccountHierarchyId: string, clAccountId: string, customerId: number): Promise<Array<MenuItem>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Dashboard/AccountMenu/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { sideMenu: sideMenu, hierarchyId: hierarchyId, subAccountHierarchyId: subAccountHierarchyId, clAccountId: clAccountId, customerId: customerId }

    return AjaxWrapper.get<Array<MenuItem>, any>(url, data);
  }
}

